var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto",style:(_vm.style)},[_vm._l((_vm.data.widgets),function(widget){return [_vm._t("default",null,{"data":widget,"spaceLeft":_vm.constrainSpaceLeft})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }